<template>
    <div class="pdfviewdiv" :class="{'pdfviewcss': pdfviewtheme==='pdfviewcss'}">
      <vue-pdf-app class="formatpdf"
      :pdf="pdfiframe" 
      :title="true"
      
      ></vue-pdf-app>
    </div>
  </template>
>

<script>
import VuePdfApp from "vue3-pdf-app";
import "vue3-pdf-app/dist/icons/main.css";

export default {
props: ['pdfiframe', 'pdfviewtheme'],
components: {
    VuePdfApp
  }
}
</script>

<style>


/*===================MEDIA SCREENS TAMPLATES===============*/
 /* Extra small devices (phones, 600px and down) */
 @media only screen and (max-width: 600px) {

  .formatpdf {
    height: 800px; 
    width: 400px
  }
  .col-md-4 {
    margin-top: 100px;
    }

 
 }

 /* Small devices (portrait tablets and large phones, 600px and up) */
 @media only screen and (min-width: 600px) {
  .formatpdf {
    height: 800px; 
    width: 600px
  }
  .col-md-4 {
    margin-top: 100px;
    }
 }
 
 /* Medium devices (landscape tablets, 768px and up) */
 @media only screen and (min-width: 768px) {
  .formatpdf {
    height: 800px; 
    width: 800px
  }
  
 }
 
 /* Large devices (laptops/desktops, 992px and up) */
 @media only screen and (min-width: 992px) {

 }
 
 /* Extra large devices (large laptops and desktops, 1200px and up) */
 @media only screen and (min-width: 1200px) {
 
  .formatpdf {
    height: 1000px; 
    width: 900px
  }
 } 
</style>